import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupInfoPipe',
  standalone: false,
  pure: true
})
export class GroupInfoPipe implements PipeTransform {

  transform(groupDataMap: Record<string, any> | null | undefined, movementId: number, conceptId: number): any {
    if (!groupDataMap || movementId == null || conceptId == null) {
      return null;
    }
    return groupDataMap[`${movementId}_${conceptId}`];
  }

}
